export default {
  palette: {
    primary: {
      main: '#2196f3',
    },
  },
}



// WEBPACK FOOTER //
// ./src/theme.js